import { render, staticRenderFns } from "./AspectTableSingleEdit.vue?vue&type=template&id=baac2056&scoped=true&"
import script from "./AspectTableSingleEdit.vue?vue&type=script&lang=js&"
export * from "./AspectTableSingleEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baac2056",
  null
  
)

export default component.exports